import { HttpClient, HttpContext } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
import { EnbwIbanValidationResult } from '@onedv-portal/api'
import { SPINNER_ENABLED, SPINNER_TITLE } from '../interceptors/loading-spinner.interceptor'

@Injectable({
  providedIn: 'root',
})
export class ValidationService {
  private readonly http = inject(HttpClient)

  validateIban(value: string): Observable<EnbwIbanValidationResult> {
    console.log('Validating IBAN:', value)
    return this.http.get<EnbwIbanValidationResult>(`${environment.apiUrl}/validation/iban`, {
      params: { value },
      context: new HttpContext().set(SPINNER_ENABLED, true).set(SPINNER_TITLE, 'Bankdaten werden abgerufen...'),
    })
  }

  validateSteuernummer(value: string): Observable<EnbwIbanValidationResult> {
    return this.http.get<EnbwIbanValidationResult>(`${environment.apiUrl}/validation/steuernummer`, {
      params: { value },
      context: new HttpContext().set(SPINNER_ENABLED, true).set(SPINNER_TITLE, 'Steuerdaten werden validiert...'),
    })
  }

  validateUmsatzsteuerId(value: string): Observable<EnbwIbanValidationResult> {
    return this.http.get<EnbwIbanValidationResult>(`${environment.apiUrl}/validation/umsatzsteuerId`, {
      params: { value },
      context: new HttpContext().set(SPINNER_ENABLED, true).set(SPINNER_TITLE, 'Steuerdaten werden validiert...'),
    })
  }
}
